import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TokenizedPaymentCard } from '@/models';
import { AccountManagementEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';

@Component({
  name: 'CmgRemovePaymentCardModal',
})
export default class CmgRemovePaymentCardModal extends Vue {
  isRemovingCard = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.removePaymentCardModal.visible;
  }

  get paymentCard(): TokenizedPaymentCard | null {
    const args = this.$appStore.state.ui.modals.removePaymentCardModal.args;

    return args ? args.token : null;
  }

  async onRemoveCard() {
    if (!this.paymentCard || !this.paymentCard.tokenId) {
      return;
    }

    this.isRemovingCard = true;

    try {
      await this.$services.transaction.deletePaymentCard(this.paymentCard.tokenId);
      await this.$services.transaction.refreshPaymentCards();
      this.$services.analytics.send(new AccountManagementEvent(`${this.paymentCard.isGiftCard ? InteractionTrackingType.RemoveGiftCard : InteractionTrackingType.RemoveCreditCard}`));
    } catch (err) {
      // TODO-ntfpbp: Handle error in UI
    }

    this.onRemoveclose();
    this.isRemovingCard = false;
  }

  onRemoveclose() {
    this.$services.ui.setModalVisibility('removePaymentCardModal', false);
    const lastSelectedElement = this.$appStore.state.ui.lastSelectedElement;
    if (lastSelectedElement) {
      if (lastSelectedElement.one == 'slot-wrapper remove-gift-btn') {
        this.$services.ui.nextFocus('add-gift-btn');
      } else {
        const focusaddCard = document.getElementsByClassName('addNewcard')[0] as HTMLElement;
        if (focusaddCard) {
          focusaddCard.focus();
        }
        const focusaddAnothercard = document.getElementsByClassName('addAnothercard')[0] as HTMLElement;
        if (focusaddAnothercard) {
          focusaddAnothercard.focus();
        }
      }
    }
    this.$services.ui.clearLastSelectedElement();
  }

  onClose() {
    this.$services.ui.setModalVisibility('removePaymentCardModal', false);
    this.$services.ui.focusBack();
  }
}
